import * as React from 'react'
import {Box,Typography,Paper,Grid,TextField,Container,Button,CircularProgress,InputAdornment,IconButton} from '@mui/material'
import {styled,useTheme} from '@mui/material/styles'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import MailIcon from '@mui/icons-material/Mail';
import HomeIcon from '@mui/icons-material/Home';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {useSelector, useDispatch} from 'react-redux';
import { login,} from "../Redux/authSlice";
import {useNavigate} from 'react-router-dom'
import ValidationField from '../Components/ValidationField'
import register from '../Redux/reducers/register'
import { add_test,} from "../Redux/testSlice";
import { add_tests,} from "../Redux/testsSlice";
import { set_setting } from '../Redux/settingSlice';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import Lottie from "lottie-react";
import { CalendarMonth, Flag, PhoneAndroid } from '@mui/icons-material';
import AutoInput from '../Components/AutoInput';
import SelectInput from '../Components/SelectInput';

const StartBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
	width: 10,
	backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
	backgroundColor: '#ffffff',
	borderRadius: 10
},
minHeight:300,
display:"flex",
flexWrap:"wrap",
justifyContent:"space-evenly",
paddingTop:10,
borderRadius:10,
maxWidth:"90%",
flexDirection:"row"
})
);

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
height: 7,
width:200,
borderRadius: 5,
[`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
},
[`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#c99405',
},
}));

const Sign = ()=>{

const theme = useTheme()
const [email,setEmail] = React.useState('');
const [last_name,setLast_name] = React.useState('');
const [first_name,setFirst_name] = React.useState('');
const [organization,setOrganization] = React.useState('');
const [password,setPassword] = React.useState('')
const [message, setMessage] = React.useState("");
const [co_password,setCo_password] = React.useState('')
const [loading,setLoading] = React.useState(false)
const [visible, setVisible] = React.useState(false);
const [isNext, setIsNext] = React.useState(false);
const [open, setOpen] = React.useState(false);
const [type, setType] = React.useState("error");
const [isDetail, setIsDetail] = React.useState(false);
const [isCredential, setIsCredential] = React.useState(true);
const [nationality, setNationality] = React.useState("");
const [sex, setSex] = React.useState("Male");
const [tel, setTel] = React.useState("");
const [dateBirth, setDateBirth] = React.useState("");
const navigate = useNavigate()
const size_xs = useMediaQuery(theme.breakpoints.up('xs'));
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const user = useSelector(state => state?.auth.user);
const dispatch = useDispatch()

const handleSign = async  ()=>{
try{
    if (tel !== '' && email !== '' && password !== '' && last_name !== '' && first_name !== '' && nationality !== '' && dateBirth!== '') {

    const data ={
        email:email,
        password:password,
        last_name:last_name,
        first_name:first_name,
        nationality:nationality,
        tel:tel,
        sex:sex,
        birthday:dateBirth,
        organization:organization,
        profile:"https://"
    }


    setLoading(true)

    register(login,set_setting,dispatch,data,setOpen,setMessage,add_test,add_tests,setLoading,navigate)

    } else {
        setMessage("please write your email or password")
        setType("error")
        setOpen(true)
    }
}catch(err){
    console.log(err)
}
}

const toggleVisibility = () => {
setVisible(!visible);
};

const handleSnackbarClose = ()=>{
setOpen(false)
}

const sex_types = ["Male","Female","Other"]

return(
<Grid container>
    <Grid item xs={12} sm={12} md={12} style={{height:70}}>
    </Grid>
    <Grid item xs={12} sm={12} md={12} sx={{justifyContent:"center",alignItems:"center",marginLeft:{xs:3,md:15}}}>
        <Snackbar anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }} message={message} 
            onClose={handleSnackbarClose} 
            open={open} 
            autoHideDuration={2000}

        />
        <StartBox sx={{background:{xs:"#000000",md:"#100101"}}}>
        <Box sx={{maxWidth:400,minWidth:350}}>
            <form style={{backgroundColor:"black",padding:10,marginTop:10,marginBottom:10,boxShadow:"0px 0px 10px 2px rgba(0,0,0,0.2)",borderRadius:15,width:"100%"}}>
                <Box m={1} display="flex" flexDirection="row">
                    <img width={50} height={50} src={require('../assets/itest.png')}/>
                    <Typography  mb={3} mt={1} ml={2} fontSize={30} color="gold" fontWeight={900} sx={{fontFamily:"zolla"}}>
                        iTest
                    </Typography>
                </Box>
                <Box m={1} display="flex" width="90%" flexDirection="row" justifyContent={(isNext || isDetail) ? "space-between" : "flex-start"} >
                    <Typography  mb={1} mt={2}  variant="h6" color="gold" fontWeight={900} sx={{fontFamily:"dinofans"}}>
                        Create an account
                    </Typography>
                    {
                       ( isNext || isDetail) && (
                            <IconButton sx={{borderRadius:1}} onClick={()=>{
                                if(isDetail){
                                    setIsCredential(true)
                                    setIsDetail(false)
                                }else{
                                    setIsNext(false)
                                    setIsDetail(true)
                                }
                            }}>
                                <ArrowIcon/>
                            </IconButton>
                        )
                    }
                </Box>
                <Box mb={1} ml={2}>
                    <BorderLinearProgress variant="determinate" value={isCredential ? 10 : isDetail ? 70 : 100} />
                </Box>
                {
                    isCredential && (
                        <>
                    <Box ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            E-mail *
                        </Typography> 
                        <TextField
                            label="email"
                            onChange={(e)=>{setEmail(e.target.value)}}
                            placeholder='email...'
                            type="text"
                            sx={{minHight:30,maxWidth:280}}
                            value={email}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <MailIcon /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box> 
                    <Box mt={2} ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Password *
                        </Typography> 
                        <TextField
                        placeholder='Password...'
                        type={visible ? 'text' : 'password'}
                        sx={{minHight:30,maxWidth:280}}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                <IconButton onClick={toggleVisibility}>
                                    {visible ? <VisibilityIcon fontSize='15'/> : <VisibilityOffIcon fontSize='15'/>}
                                </IconButton>
                                </InputAdornment>
                            )
                            }}
                        label="Password"
                        value={password}
                        onChange={(e)=>{setPassword(e.target.value)}}
                        />
                    </Box>
                    <Box mt={2} ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Confirm Password *
                        </Typography> 
                        <TextField
                            placeholder='Confirm Password...'
                            type={visible ? 'text' : 'password'}
                            sx={{minHight:30,maxWidth:280}}
                            InputProps={{
                            endAdornment: (
                                <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                <IconButton onClick={toggleVisibility}>
                                    {visible ? <VisibilityIcon fontSize='15'/> : <VisibilityOffIcon fontSize='15'/>}
                                </IconButton>
                                </InputAdornment>
                            )
                            }}
                        label="Password"
                        value={co_password}
                        onChange={(e)=>{setCo_password(e.target.value)}}
                        />
                    </Box> 
                    </>
                    )
                }
                {
                    isDetail && (
                        <>
                        <Box ml={1}>
                            <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                                Sex *
                            </Typography> 
                            <SelectInput
								data={sex_types}
								setInput={setSex}
								input={sex}
                                width={280}
								label="Sex "
							/>
                        </Box> 
                        <Box mt={2} ml={1}>
                            <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                                Nationality *
                            </Typography> 
                            <TextField
                                label="Nationality"
                                onChange={(e)=>{setNationality(e.target.value)}}
                                placeholder='Nationality...'
                                type="text"
                                sx={{minHight:30,maxWidth:280}}
                                value={nationality}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                            <Flag /> 
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        <Box mt={2} ml={1}>
                            <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                                Birthday
                            </Typography> 
                            <TextField
                                // placeholder='Birthday..'
                                type='date'
                                sx={{minHight:30,maxWidth:280}}
                                InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <IconButton >
                                            <CalendarMonth fontSize='15'/>
                                        </IconButton>
                                    </InputAdornment>
                                )
                                }}
                            // label="Organization"
                            value={dateBirth}
                            onChange={(e)=>{setDateBirth(e.target.value)}}
                            />
                        </Box> 
                    </>
                )
            }
            {
                isNext && (
                    <>
                    <Box ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            First Name *
                        </Typography> 
                        <TextField
                            label="First name"
                            onChange={(e)=>{setFirst_name(e.target.value)}}
                            placeholder='First name...'
                            type="text"
                            sx={{minHight:30,maxWidth:280}}
                            value={first_name}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <MailIcon /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box> 
                    <Box mt={2} ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Last Name *
                        </Typography> 
                        <TextField
                            label="Last name"
                            onChange={(e)=>{setLast_name(e.target.value)}}
                            placeholder='Last name...'
                            type="text"
                            sx={{minHight:30,maxWidth:280}}
                            value={last_name}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <MailIcon /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                    <Box mt={2} ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Tel *
                        </Typography> 
                        <TextField
                            label="Tel"
                            onChange={(e)=>{setTel(e.target.value)}}
                            placeholder='Tel...'
                            type="text"
                            sx={{minHight:30,maxWidth:280}}
                            value={tel}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <PhoneAndroid /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                    <Box mt={2} ml={1}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                            Organization
                        </Typography> 
                        <TextField
                        placeholder='Organization..'
                        type='text'
                        sx={{minHight:30,maxWidth:280}}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                <IconButton >
                                    <HomeIcon fontSize='15'/>
                                </IconButton>
                                </InputAdornment>
                            )
                            }}
                        label="Organization"
                        value={organization}
                        onChange={(e)=>{setOrganization(e.target.value)}}
                        />
                    </Box> 
                </>
            )
        }
            <Box mt={2} ml={2} sx={{flexDirection:{xs:"column",md:"row"}}}>
                <Button onClick={(e)=>{
                    e?.preventDefault()
                    if(isNext){
                        handleSign()
                    }else if(isCredential){
                        if(email !== '' && password !== '' && co_password !== ''){
                            if(password === co_password){
                            setIsDetail(true)
                            setIsCredential(false)
                            setIsNext(false)
                            }else{
                                setMessage("Passwords does not match")
                                setOpen(true)
                            }
                        }else{
                            setMessage("please complete the whole form")
                            setOpen(true)
                        }
                    }else{
                        if(sex !== '' && dateBirth !== '' && nationality !== ''){
                            setIsDetail(false)
                            setIsCredential(false)
                            setIsNext(true)
                        }else{
                            setMessage("please complete the whole form")
                            setOpen(true)
                        }
                    }
                }} disabled={loading ? true : false} sx={{backgroundColor:"gold",color:"black",marginRight:2,fontSize:{xs:10,md:12},height:35,width:120,fontFamily:"dinofans"}} variant="contained">
                    {
                        isNext && loading ? <CircularProgress size={20} style={{color:"black"}}/> : isNext && !loading ? "Create" : "Next"
                    }
                </Button>
            </Box>
            <Typography  sx={{fontWeight:500,color:"white",margin:3,fontSize:13}}>
                Do you have an account ? 
                <button onClick={(e)=>{
                        e?.preventDefault()
                        navigate('/login')
                    }} style={{fontWeight:500,color:"gold",marginLeft:10,fontSize:13,background:"transparent",borderWidth:0,fontFamily:"geruduk"}}>
                    Log in now
                </button>
            </Typography>
            
        </form>
    </Box>
            <Box sx={{width:{xs:"100%",md:"45%"}}} display="block" justifyContent="flex-start" alignItems="flex-start" pt={3}>
                <Box sx={{display:{xs:"none",md:"block"},textAlign:"center",width:"100%"}}>
                    <Typography fontWeight={500} mb={2} sx={{marginLeft:{xs:0,md:4,fontFamily:"dinofans",fontSize:25}}} color="#ffffff" textAlign="center">
                        TALENT ASSESSMENT HIRING 
                    </Typography>
                    <Lottie style={{width:200,height:250,marginLeft:120}} animationData={require("../assets/anim2.json")}  />
                </Box>
               <Box flexDirection="row" display="flex" ml={2} sx={{justifyContent:"space-evenly",alignContent:"center",width:"98%"}}>
                    <Box sx={{width:"80%",padding:1}}>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontFamily:"dinofans"}}>
                                USE AI FOR AN ASSESSMENT HIRING
                        </Typography>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontSize:13,marginTop:2}}>
                            we make individuals or organizations to process the assessment to hire employers in any field using Google's Generative Text AI  Gemini  to create assessments and  advanced technics to post a job offer and manage it using an ATS
                        </Typography> 
                    </Box>
                </Box>
            </Box>
        </StartBox>
    </Grid>
    <Grid item xs={12} sm={12} md={12} style={{height:40}}>
    </Grid>
</Grid>
)}

export default Sign